import { GlossDateAbstraction } from "@bitwarden/web-vault/app/models/data/shared/gloss-date/gloss-date.abstraction";
import {
  dateProperties,
  GlossDateInterface,
} from "@bitwarden/web-vault/app/models/data/shared/gloss-date/gloss-date.interface";
import { DateAsISOStringType } from "@bitwarden/web-vault/app/models/store/types/store.types";

/**
 * GlossDate class has no time information.
 * It is just a date, so we must guess the best time for enrichment
 */
export class GlossDate extends GlossDateAbstraction implements GlossDateInterface, dateProperties {
  date: DateAsISOStringType; // store the date as an ISO string in UTC timezone
  dateString: string; // store the date as a string in the timezone of original date
  timeZone: string; // store the timezone of the original date or the original local timezone when the date was created
  offset: number; // store the offset in minutes from UTC, positive for east of UTC, negative for west of UTC
}
